export default "__VITE_ASSET__BR_ZjpDM__"